import { formatDisplayDateTime } from '@/utils/date';
import { formatNumber, formatTaka } from '@/utils/number';
import type { PcmpQueuePerson } from '../../types/pcmpQueue.types';
import { PcmpEmptyCell } from '../PcmpQueue/PcmpQueueCells';

/** A batch's size; with filters set, the matching members over the total. */
export function PcmpBatchItemsCell({
  batch,
}: {
  batch: { itemCount: number; matchedItemCount: number | null };
}) {
  if (batch.matchedItemCount === null) {
    return <span className="tabular-nums">{formatNumber(batch.itemCount)}</span>;
  }
  return (
    <span className="whitespace-nowrap tabular-nums" title="Matching the filters / in the batch">
      {formatNumber(batch.matchedItemCount)}
      <span className="text-muted-foreground"> / {formatNumber(batch.itemCount)}</span>
    </span>
  );
}

/** Who did a batch step and when. */
export function PcmpBatchStepCell({ by, at }: { by: PcmpQueuePerson | null; at: string | null }) {
  if (!at) return <PcmpEmptyCell />;
  return (
    <div className="flex max-w-52 flex-col">
      <span className="truncate font-medium" title={by?.fullName}>
        {by?.fullName ?? 'Unknown'}
      </span>
      <span className="text-xs whitespace-nowrap text-muted-foreground">
        {formatDisplayDateTime(at)}
      </span>
    </div>
  );
}

/** A batch bucket's amount over its count; a dash when empty. */
export function PcmpBatchAmountCell({ value }: { value: { count: number; amount: number } }) {
  if (value.count === 0) {
    return (
      <div className="text-right">
        <PcmpEmptyCell />
      </div>
    );
  }
  return (
    <div className="flex flex-col text-right whitespace-nowrap tabular-nums">
      <span>{formatTaka(value.amount)}</span>
      <span className="text-xs text-muted-foreground">{formatNumber(value.count)}</span>
    </div>
  );
}
